/**
 * User-facing copy for Materiah AI chat (placeholder + empty-session greeting).
 * Keep aligned with project-docs/MATERIAH_APP_CAPABILITIES.md.
 */

/** Composer textarea placeholder. */
export const AI_CHAT_COMPOSER_PLACEHOLDER =
  'Ask about inventory, orders, quotes, projects, budgets, organoid requests, or where to find something…';

/**
 * Opening assistant message when a session has no messages yet.
 * Uses in-app markdown links ([Label](/path)) rendered by AiChatMessageBody.
 */
export const AI_CHAT_WELCOME_MESSAGE = `Hi! 👋

Ask me anything about **inventory**, **orders**, **quotes**, **suppliers**, **projects**, **budgets**, **Lab Data**, **organoid requests**, notifications, or **how to get around Materiah**.

I can point you to the right screens — for example [Inventory](/inventory) 📦, [Orders](/orders), [Quotes](/quotes) 📄, [Projects](/projects), [Budgets](/budgets), or [Organoid requests](/organoid-requests) 🧫 — and cite live records when I find them.`;
